import { useMemo } from "react";

import { propTypes } from "redux-form";

import { Step } from "@dpdgroupuk/mydpd-ui";

import PackageDetailsContent from "~/components/PackageDetailsContent";
import { PACKAGE_DETAILS } from "~/constants/forms";
import { HELP_INFO } from "~/constants/info";
import * as S from "~/constants/strings";
import { ShipmentModels } from "~/models";
import PropTypes from "prop-types";

const PackageDetails = props => {
  const {
    createShipmentSyncErrors,
    createShipmentSubmitErrors,
    createShipmentAsyncErrors,
  } = props;

  const isValidPackageDetailsSection = useMemo(
    () =>
      ShipmentModels.isValidPackageDetailsSection(
        createShipmentSyncErrors,
        createShipmentSubmitErrors,
        createShipmentAsyncErrors
      ),
    [
      createShipmentSyncErrors,
      createShipmentSubmitErrors,
      createShipmentAsyncErrors,
    ]
  );

  return (
    <Step
      totalSteps={props.totalSteps}
      step={props.step}
      withStepCounter
      isLoading={props.isLoadingOutboundServices}
      complete={!props.pristine && isValidPackageDetailsSection}
      title={S.PACKAGE_DETAILS}
      help={HELP_INFO[PACKAGE_DETAILS]}
      helpModalTitle={S.PACKAGE_DETAILS}
    >
      <PackageDetailsContent {...props} />
    </Step>
  );
};

PackageDetails.propTypes = {
  ...propTypes,
  createShipmentAsyncErrors: PropTypes.object,
};

export default PackageDetails;
